import { createFileRoute } from '@tanstack/react-router'
import { BillingSettingsPage } from '@/features/billing/components/billing-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/billing',
)({
  component: BillingSettingsPage,
  beforeLoad: async () => {
    return {
      title: 'Billing',
      headerTitleKey: 'header.billing.title',
      headerDescriptionKey: 'header.billing.description',
    }
  },
})
